export default __webpack_public_path__ + "static/media/aravind.921c9bd6.png";